import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import MissingTrimsView from '@/views/MissingTrimsView.vue';
import AdminView from '@/views/AdminView.vue';
import AdminHomeView from '@/views/AdminHomeView.vue';

declare global {
  interface Window {
    __JZL_DOOR_EMBEDDED__?: boolean;
    __JZL_DOOR_LOADED__?: boolean;
    __JZL_DOOR_QUEUE__?: ShadowRoot[];
    __JZL_DOOR_INIT__?: () => void;
  }
}

/** Call once per widget instance — each instance needs its own router. */
export function createAppRouter() {
  const isEmbedded = typeof window !== 'undefined' && !!window.__JZL_DOOR_EMBEDDED__;
  return createRouter({
    // Hash history is required for CX embeds on arbitrary host paths (e.g. /test.html).
    history: isEmbedded
      ? createWebHashHistory(import.meta.env.BASE_URL)
      : createWebHistory(import.meta.env.BASE_URL),
    routes: [
      {
        path: '/admin',
        component: AdminView,
        redirect: { name: 'admin-settings' },
        children: [
          {
            path: 'settings',
            name: 'admin-settings',
            component: AdminHomeView,
          },
          {
            path: 'missing-trims',
            name: 'admin-missing-trims',
            component: MissingTrimsView,
          },
        ],
      },
      {
        path: '/',
        name: 'home',
        component: HomeView,
      },
      {
        path: '/missing-trims',
        redirect: (to) => ({
          name: 'admin-missing-trims',
          query: to.query,
          hash: to.hash,
        }),
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('../views/AboutView.vue'),
      },
      // Catch-all for path-based selection URLs:
      // e.g. /year/2024/make/Ford/model/Maverick/trim/LE/color/Oxford White
      {
        path: '/:pathMatch(.*)*',
        name: 'home-selection',
        component: HomeView,
      },
    ],
  });
}
